import React from "react";
import { Link } from "react-router-dom";
import project1 from "../../assets/reGame.jpg";
import project2 from "../../assets/shuterUp.jpg";
import project3 from "../../assets/SkillEdge.jpg";

const Projects = () => {
    return (
        <div className="mt-28 mb-20 w-5/6 mx-auto">
            {/* Title Section start */}
            <div className="text-center">
                <h2 className="font-extrabold uppercase text-4xl dark:text-[#E9F8F9]">
                    {/* <span class="underline decoration-blue-500">Projects</span> */}
                    Projects
                </h2>
                <p className="dark:text-[#E9F8F9]">
                    ./ <span className="underline">projects</span>|
                </p>
            </div>
            {/* Title Section end */}

            {/* Project Component Start */}
            <div className="my-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                <div className="hover:text-[#98A8F8]">
                    <img
                        className="h-[210px] rounded-md duration-200 hover:scale-105"
                        // className="h-[210px] rounded-md"
                        src={project1}
                        alt="websiteImage"
                    />
                    <h3 className="text-center mt-3 font-extrabold dark:text-[#E9F8F9] dark:hover:text-[#98A8F8]">
                        <Link to="/projects/regame">reGame</Link>
                    </h3>
                </div>
                <div className="hover:text-[#98A8F8]">
                    <img
                        className="h-[210px] rounded-md duration-200 hover:scale-105"
                        src={project2}
                        alt="websiteImage"
                    />
                    <h3 className="text-center mt-3 font-extrabold dark:text-[#E9F8F9] dark:hover:text-[#98A8F8]">
                        <Link to="/projects/shuterup">shuterUp</Link>
                    </h3>
                </div>
                <div className="hover:text-[#98A8F8]">
                    <img
                        className="h-[210px] rounded-md duration-200 hover:scale-105"
                        src={project3}
                        alt="websiteImage"
                    />
                    <h3 className="text-center mt-3 font-extrabold dark:text-[#E9F8F9] dark:hover:text-[#98A8F8]">
                        <Link to="/projects/skilledge">skillEdge</Link>
                    </h3>
                </div>
            </div>
            {/* Project Component end */}
        </div>
    );
};

export default Projects;
